import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/all.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { CartProvider } from './context/CartContext';
import { StickyHeaderProvider } from './context/StickyHeaderContext';
import { MessageProvider } from './context/MessageContext';

axios.defaults.baseURL = process.env.REACT_APP_API_URL; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <MessageProvider>
        <StickyHeaderProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </StickyHeaderProvider>
      </MessageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
